export default __webpack_public_path__ + "static/media/story.e3fd79fb.webp";